import type { ReactNode, SVGProps } from "react";

export type StatusGlyphName =
  | "attention"
  | "check"
  | "clock"
  | "close"
  | "information"
  | "processing"
  | "search"
  | "neutral";

export interface StatusGlyphProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  name: StatusGlyphName;
}

export function StatusGlyph({ name, ...props }: StatusGlyphProps) {
  const paths: Record<StatusGlyphName, ReactNode> = {
    attention: <path d="M12 8v5m0 3h.01M4.7 19h14.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.1a1.5 1.5 0 0 0-2.6 0L3.4 16.75A1.5 1.5 0 0 0 4.7 19Z" />,
    check: <path d="m5 12 4.2 4.2L19 6.5" />,
    clock: <path d="M12 7v5l3.5 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />,
    close: <path d="m6 6 12 12M18 6 6 18" />,
    information: <path d="M12 10v7m0-10h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />,
    processing: <path d="M20 12a8 8 0 1 1-2.34-5.66" />,
    search: <path d="m20 20-4.5-4.5M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />,
    neutral: <path d="M5 12h14" />,
  };

  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      viewBox="0 0 24 24"
      {...props}
    >
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        {paths[name]}
      </g>
    </svg>
  );
}
